import { tryOnMounted } from './tryOnMounted';
import { ref } from 'vue';
export function useSupported(callback, sync = false) {
    const isSupported = ref();
    const update = () => (isSupported.value = Boolean(callback()));
    update();
    tryOnMounted(update, sync);
    return isSupported;
}
